type SelfReportedDetail = {
  isScreenshotReported: boolean;
  postName: string;
};

/**
 * A deliverable renders with the self-reported layout (screenshot-verified
 * metrics, no comments/saves) when the backend explicitly flagged it, or —
 * for legacy rows recorded before that flag existed — when its post name
 * still carries "story"/"historia" as a fallback signal. Keep the union: a
 * narrower check (flag only) would stop any deliverable that only matches
 * the postName fallback from rendering with the right layout.
 */
export const isScreenshotReportedDeliverable = (
  detail: SelfReportedDetail,
): boolean =>
  detail.isScreenshotReported ||
  detail.postName.toLowerCase().includes("story") ||
  detail.postName.toLowerCase().includes("historia");
